// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Json$BwaxAdmin = require("../../../utils/json.bs.js");
var Plate$BwaxAdmin = require("../../../plate.bs.js");
var Lang_eval$BwaxAdmin = require("../../lang_eval.bs.js");
var Caml_chrome_debugger = require("bs-platform/lib/js/caml_chrome_debugger.js");
var Runtime_common$BwaxAdmin = require("../runtime_common.bs.js");
var Lang_value_dict$BwaxAdmin = require("../../lang_value_dict.bs.js");

var module_name = "Json";

function invalid_args(name) {
  throw [
        Lang_eval$BwaxAdmin.Eval_exn,
        "Json." + (name + ": Invalid Arguments")
      ];
}

function pack_func(arity, f) {
  return /* tuple */[
          /* V_native_fn */Caml_chrome_debugger.variant("V_native_fn", 4, [
              arity,
              f,
              /* [] */0
            ]),
          Runtime_common$BwaxAdmin.nt
        ];
}

function pack_json(j) {
  return /* tuple */[
          /* V_tagged_raw */Caml_chrome_debugger.variant("V_tagged_raw", 8, [
              "JSON",
              j
            ]),
          Runtime_common$BwaxAdmin.nt
        ];
}

var default_config = /* record */Caml_chrome_debugger.record([
    "keeping_native",
    "nothing_to_null",
    "processors"
  ], [
    false,
    false,
    0
  ]);

function any_value_to_json(config, _v) {
  while(true) {
    var v = _v;
    var trans_list = function (l) {
      return Curry._1(Plate$BwaxAdmin.List.to_array, Plate$BwaxAdmin.List.keep_map((function (param) {
                        return any_value_to_json(config, param);
                      }), l));
    };
    var trans_al = function (al) {
      return Js_dict.fromList(Plate$BwaxAdmin.List.keep_map((function (param) {
                        var k = param[0];
                        return Plate$BwaxAdmin.$$Option.map((function (j) {
                                      return /* tuple */[
                                              k,
                                              j
                                            ];
                                    }), any_value_to_json(config, param[1]));
                      }), al));
    };
    var alt = v[0];
    if (typeof alt === "number") {
      if (alt === /* V_unit */0 || !config[/* keeping_native */0]) {
        return ;
      } else {
        return Caml_option.some(v);
      }
    } else {
      switch (alt.tag | 0) {
        case /* V_tuple */0 :
        case /* V_list */1 :
            return Caml_option.some(trans_list(alt[0]));
        case /* V_record */2 :
            return Caml_option.some(trans_al(alt[0]));
        case /* V_literal */5 :
            var lit = alt[0];
            var tmp;
            if (typeof lit === "number") {
              switch (lit) {
                case /* NaN */0 :
                    tmp = "NaN";
                    break;
                case /* Infinity */1 :
                    tmp = "Infinity";
                    break;
                case /* NegInfinity */2 :
                    tmp = "-Infinity";
                    break;
                
              }
            } else {
              switch (lit.tag | 0) {
                case /* Int */0 :
                    tmp = lit[0];
                    break;
                case /* Char */3 :
                    tmp = Plate$BwaxAdmin.Str.from_char(lit[0]);
                    break;
                default:
                  tmp = lit[0];
              }
            }
            return Caml_option.some(tmp);
        case /* V_tagged */6 :
            var name = alt[0];
            switch (name) {
              case "Just" :
                  var match = alt[1];
                  if (match && !match[1]) {
                    _v = match[0];
                    continue ;
                  }
                  break;
              case "Nothing" :
                  if (!alt[1]) {
                    if (config[/* nothing_to_null */1]) {
                      return Caml_option.some(null);
                    } else {
                      return ;
                    }
                  }
                  break;
              default:
                
            }
            var match$1 = Plate$BwaxAdmin.List.assoc(name, config[/* processors */2]);
            if (match$1 !== undefined) {
              return Curry._1(match$1, v);
            } else {
              var values = Curry._1(Plate$BwaxAdmin.List.to_array, Plate$BwaxAdmin.List.keep_map((function (param) {
                          return any_value_to_json(config, param);
                        }), alt[1]));
              return Caml_option.some(Js_dict.fromList(/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                /* tuple */[
                                  "__t__",
                                  name
                                ],
                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                    /* tuple */[
                                      "__v__",
                                      values
                                    ],
                                    /* [] */0
                                  ])
                              ])));
            }
            break;
        case /* V_raw */7 :
            return Caml_option.some(alt[0]);
        case /* V_tagged_raw */8 :
            switch (alt[0]) {
              case "Dict" :
                  return Caml_option.some(Js_dict.fromList(Plate$BwaxAdmin.List.keep_map((function (param) {
                                        var match = param[0][0];
                                        if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                          return ;
                                        } else {
                                          var match$1 = match[0];
                                          if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
                                            return ;
                                          } else {
                                            var s = match$1[0];
                                            return Plate$BwaxAdmin.$$Option.map((function (jv) {
                                                          return /* tuple */[
                                                                  s,
                                                                  jv
                                                                ];
                                                        }), any_value_to_json(config, param[1]));
                                          }
                                        }
                                      }), Lang_value_dict$BwaxAdmin.to_list(alt[1]))));
              case "File" :
              case "Image" :
              case "JSON" :
                  return Caml_option.some(alt[1]);
              default:
                return Caml_option.some(alt[1]);
            }
        case /* V_tagged_number */9 :
            if (alt[0] === "Date") {
              return Caml_option.some(new Date(alt[1]).toJSON());
            } else {
              return ;
            }
        case /* V_tagged_string */10 :
            return Caml_option.some(alt[1]);
        case /* V_array */12 :
            return Caml_option.some(trans_list(Curry._1(Plate$BwaxAdmin.List.from_array, alt[0])));
        case /* V_decorated */13 :
            _v = alt[1];
            continue ;
        case /* V_sum_type */11 :
        case /* V_executable */14 :
            return ;
        default:
          if (config[/* keeping_native */0]) {
            return Caml_option.some(v);
          } else {
            return ;
          }
      }
    }
  };
}

function any_value_to_plain_json(j) {
  return any_value_to_json(default_config, j);
}

var external_vals_000 = /* tuple */[
  "string",
  pack_func(1, (function (param) {
          if (param) {
            var match = param[0][0];
            if (typeof match === "number" || match.tag !== /* V_literal */5) {
              return invalid_args("string");
            } else {
              var match$1 = match[0];
              if (typeof match$1 === "number" || !(match$1.tag === /* String */2 && !param[1])) {
                return invalid_args("string");
              } else {
                return pack_json(match$1[0]);
              }
            }
          } else {
            return invalid_args("string");
          }
        }))
];

var external_vals_001 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    /* tuple */[
      "int",
      pack_func(1, (function (param) {
              if (param) {
                var match = param[0][0];
                if (typeof match === "number" || match.tag !== /* V_literal */5) {
                  return invalid_args("int");
                } else {
                  var match$1 = match[0];
                  if (typeof match$1 === "number" || match$1.tag || param[1]) {
                    return invalid_args("int");
                  } else {
                    return pack_json(match$1[0]);
                  }
                }
              } else {
                return invalid_args("int");
              }
            }))
    ],
    /* :: */Caml_chrome_debugger.simpleVariant("::", [
        /* tuple */[
          "float",
          pack_func(1, (function (param) {
                  if (param) {
                    var match = param[0][0];
                    if (typeof match === "number" || match.tag !== /* V_literal */5) {
                      return invalid_args("float");
                    } else {
                      var match$1 = match[0];
                      if (typeof match$1 === "number") {
                        return invalid_args("float");
                      } else {
                        switch (match$1.tag | 0) {
                          case /* Int */0 :
                              if (param[1]) {
                                return invalid_args("float");
                              } else {
                                return pack_json(match$1[0]);
                              }
                          case /* Float */1 :
                              if (param[1]) {
                                return invalid_args("float");
                              } else {
                                return pack_json(match$1[0]);
                              }
                          default:
                            return invalid_args("float");
                        }
                      }
                    }
                  } else {
                    return invalid_args("float");
                  }
                }))
        ],
        /* :: */Caml_chrome_debugger.simpleVariant("::", [
            /* tuple */[
              "bool",
              pack_func(1, (function (param) {
                      if (param) {
                        var match = param[0][0];
                        if (typeof match === "number" || match.tag !== /* V_literal */5) {
                          return invalid_args("bool");
                        } else {
                          var match$1 = match[0];
                          if (typeof match$1 === "number" || !(match$1.tag === /* Bool */4 && !param[1])) {
                            return invalid_args("bool");
                          } else {
                            return pack_json(match$1[0]);
                          }
                        }
                      } else {
                        return invalid_args("bool");
                      }
                    }))
            ],
            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                /* tuple */[
                  "null",
                  pack_json(null)
                ],
                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                    /* tuple */[
                      "list",
                      pack_func(2, (function (param) {
                              if (param) {
                                var match = param[1];
                                if (match) {
                                  var match$1 = match[0][0];
                                  if (typeof match$1 === "number" || !(match$1.tag === /* V_list */1 && !match[1])) {
                                    return invalid_args("list");
                                  } else {
                                    var f = param[0];
                                    var p = function (v) {
                                      var match = Lang_eval$BwaxAdmin.apply_value(module_name, f, v, Runtime_common$BwaxAdmin.nt);
                                      var match$1 = match[0];
                                      if (typeof match$1 === "number" || match$1.tag !== /* V_tagged_raw */8) {
                                        return invalid_args("list");
                                      } else {
                                        return match$1[1];
                                      }
                                    };
                                    return pack_json(Curry._1(Plate$BwaxAdmin.List.to_array, Plate$BwaxAdmin.List.map(p, match$1[0])));
                                  }
                                } else {
                                  return invalid_args("list");
                                }
                              } else {
                                return invalid_args("list");
                              }
                            }))
                    ],
                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        /* tuple */[
                          "object",
                          pack_func(1, (function (param) {
                                  if (param) {
                                    var match = param[0][0];
                                    if (typeof match === "number" || !(match.tag === /* V_list */1 && !param[1])) {
                                      return invalid_args("object");
                                    } else {
                                      var p = function (param) {
                                        var match = param[0];
                                        if (typeof match === "number" || match.tag) {
                                          return invalid_args("object");
                                        } else {
                                          var match$1 = match[0];
                                          if (match$1) {
                                            var match$2 = match$1[0][0];
                                            if (typeof match$2 === "number" || match$2.tag !== /* V_literal */5) {
                                              return invalid_args("object");
                                            } else {
                                              var match$3 = match$2[0];
                                              if (typeof match$3 === "number" || match$3.tag !== /* String */2) {
                                                return invalid_args("object");
                                              } else {
                                                var match$4 = match$1[1];
                                                if (match$4) {
                                                  var match$5 = match$4[0][0];
                                                  if (typeof match$5 === "number" || !(match$5.tag === /* V_tagged_raw */8 && !match$4[1])) {
                                                    return invalid_args("object");
                                                  } else {
                                                    return /* tuple */[
                                                            match$3[0],
                                                            match$5[1]
                                                          ];
                                                  }
                                                } else {
                                                  return invalid_args("object");
                                                }
                                              }
                                            }
                                          } else {
                                            return invalid_args("object");
                                          }
                                        }
                                      };
                                      var pairs = Plate$BwaxAdmin.List.map(p, match[0]);
                                      return pack_json(Js_dict.fromList(pairs));
                                    }
                                  } else {
                                    return invalid_args("object");
                                  }
                                }))
                        ],
                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                            /* tuple */[
                              "any",
                              pack_func(1, (function (param) {
                                      if (param && !param[1]) {
                                        return Runtime_common$BwaxAdmin.pack_maybe(pack_json, any_value_to_json(default_config, param[0]));
                                      } else {
                                        return invalid_args("record");
                                      }
                                    }))
                            ],
                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                /* tuple */[
                                  "dict",
                                  pack_func(3, (function (param) {
                                          if (param) {
                                            var match = param[1];
                                            if (match) {
                                              var match$1 = match[1];
                                              if (match$1) {
                                                var match$2 = match$1[0][0];
                                                if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                                  return invalid_args("dict");
                                                } else {
                                                  var vf = match[0];
                                                  var kf = param[0];
                                                  var kp = function (k) {
                                                    return Runtime_common$BwaxAdmin.extract_string(Lang_eval$BwaxAdmin.apply_value(module_name, kf, k, Runtime_common$BwaxAdmin.nt));
                                                  };
                                                  var vp = function (v) {
                                                    return Runtime_common$BwaxAdmin.extract_json(Lang_eval$BwaxAdmin.apply_value(module_name, vf, v, Runtime_common$BwaxAdmin.nt));
                                                  };
                                                  return pack_json(Js_dict.fromList(Plate$BwaxAdmin.List.map((function (param) {
                                                                        return /* tuple */[
                                                                                kp(param[0]),
                                                                                vp(param[1])
                                                                              ];
                                                                      }), Lang_value_dict$BwaxAdmin.to_list(match$2[1]))));
                                                }
                                              } else {
                                                return invalid_args("dict");
                                              }
                                            } else {
                                              return invalid_args("dict");
                                            }
                                          } else {
                                            return invalid_args("dict");
                                          }
                                        }))
                                ],
                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                    /* tuple */[
                                      "classify",
                                      pack_func(1, (function (param) {
                                              if (param) {
                                                var match = param[0][0];
                                                if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                  return invalid_args("classify");
                                                } else {
                                                  var tag = function (s, vs) {
                                                    return /* tuple */[
                                                            /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
                                                                s,
                                                                vs
                                                              ]),
                                                            Runtime_common$BwaxAdmin.nt
                                                          ];
                                                  };
                                                  var match$1 = Js_json.classify(match[1]);
                                                  if (typeof match$1 === "number") {
                                                    switch (match$1) {
                                                      case /* JSONFalse */0 :
                                                          return tag("JSONBoolean", /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                        Runtime_common$BwaxAdmin.pack_bool(false),
                                                                        /* [] */0
                                                                      ]));
                                                      case /* JSONTrue */1 :
                                                          return tag("JSONBoolean", /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                        Runtime_common$BwaxAdmin.pack_bool(true),
                                                                        /* [] */0
                                                                      ]));
                                                      case /* JSONNull */2 :
                                                          return /* tuple */[
                                                                  /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
                                                                      "JSONNull",
                                                                      /* [] */0
                                                                    ]),
                                                                  Runtime_common$BwaxAdmin.nt
                                                                ];
                                                      
                                                    }
                                                  } else {
                                                    switch (match$1.tag | 0) {
                                                      case /* JSONString */0 :
                                                          return tag("JSONString", /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                        Runtime_common$BwaxAdmin.pack_string(match$1[0]),
                                                                        /* [] */0
                                                                      ]));
                                                      case /* JSONNumber */1 :
                                                          return tag("JSONNumber", /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                        Runtime_common$BwaxAdmin.pack_float(match$1[0]),
                                                                        /* [] */0
                                                                      ]));
                                                      case /* JSONObject */2 :
                                                          var dict = pack_json(Lang_value_dict$BwaxAdmin.from_list(Plate$BwaxAdmin.List.map((function (param) {
                                                                          return /* tuple */[
                                                                                  Runtime_common$BwaxAdmin.pack_string(param[0]),
                                                                                  pack_json(param[1])
                                                                                ];
                                                                        }), Curry._1(Plate$BwaxAdmin.List.from_array, Js_dict.entries(match$1[0])))));
                                                          return tag("JSONObject", /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                        dict,
                                                                        /* [] */0
                                                                      ]));
                                                      case /* JSONArray */3 :
                                                          var l = Plate$BwaxAdmin.List.map(pack_json, Curry._1(Plate$BwaxAdmin.List.from_array, match$1[0]));
                                                          return tag("JSONArray", /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                        Runtime_common$BwaxAdmin.pack_list(l),
                                                                        /* [] */0
                                                                      ]));
                                                      
                                                    }
                                                  }
                                                }
                                              } else {
                                                return invalid_args("classify");
                                              }
                                            }))
                                    ],
                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                        /* tuple */[
                                          "decodeString",
                                          pack_func(1, (function (param) {
                                                  if (param) {
                                                    var match = param[0][0];
                                                    if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                      return invalid_args("decodeString");
                                                    } else {
                                                      return Runtime_common$BwaxAdmin.pack_maybe(Runtime_common$BwaxAdmin.pack_string, Js_json.decodeString(match[1]));
                                                    }
                                                  } else {
                                                    return invalid_args("decodeString");
                                                  }
                                                }))
                                        ],
                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                            /* tuple */[
                                              "decodeBool",
                                              pack_func(1, (function (param) {
                                                      if (param) {
                                                        var match = param[0][0];
                                                        if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                          return invalid_args("decodeBool");
                                                        } else {
                                                          return Runtime_common$BwaxAdmin.pack_maybe(Runtime_common$BwaxAdmin.pack_bool, Js_json.decodeBoolean(match[1]));
                                                        }
                                                      } else {
                                                        return invalid_args("decodeBool");
                                                      }
                                                    }))
                                            ],
                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                /* tuple */[
                                                  "decodeInt",
                                                  pack_func(1, (function (param) {
                                                          if (param) {
                                                            var match = param[0][0];
                                                            if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                              return invalid_args("decodeInt");
                                                            } else {
                                                              var mf = Js_json.decodeNumber(match[1]);
                                                              return Runtime_common$BwaxAdmin.pack_maybe(Runtime_common$BwaxAdmin.pack_int, Plate$BwaxAdmin.$$Option.map((function (prim) {
                                                                                return prim | 0;
                                                                              }), mf));
                                                            }
                                                          } else {
                                                            return invalid_args("decodeInt");
                                                          }
                                                        }))
                                                ],
                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                    /* tuple */[
                                                      "decodeFloat",
                                                      pack_func(1, (function (param) {
                                                              if (param) {
                                                                var match = param[0][0];
                                                                if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                                  return invalid_args("decodeFloat");
                                                                } else {
                                                                  return Runtime_common$BwaxAdmin.pack_maybe(Runtime_common$BwaxAdmin.pack_float, Js_json.decodeNumber(match[1]));
                                                                }
                                                              } else {
                                                                return invalid_args("decodeFloat");
                                                              }
                                                            }))
                                                    ],
                                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                        /* tuple */[
                                                          "decodeList",
                                                          pack_func(1, (function (param) {
                                                                  if (param) {
                                                                    var match = param[0][0];
                                                                    if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                                      return invalid_args("decodeList");
                                                                    } else {
                                                                      var partial_arg = Plate$BwaxAdmin.List.map;
                                                                      return Runtime_common$BwaxAdmin.pack_maybe(Runtime_common$BwaxAdmin.pack_list, Plate$BwaxAdmin.$$Option.map((function (param) {
                                                                                        return partial_arg(pack_json, param);
                                                                                      }), Plate$BwaxAdmin.$$Option.map(Plate$BwaxAdmin.List.from_array, Js_json.decodeArray(match[1]))));
                                                                    }
                                                                  } else {
                                                                    return invalid_args("decodeList");
                                                                  }
                                                                }))
                                                        ],
                                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                            /* tuple */[
                                                              "decodeDict",
                                                              pack_func(1, (function (param) {
                                                                      if (param) {
                                                                        var match = param[0][0];
                                                                        if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                                          return invalid_args("decodeDict");
                                                                        } else {
                                                                          var partial_arg = Plate$BwaxAdmin.List.map;
                                                                          return Runtime_common$BwaxAdmin.pack_maybe((function (l) {
                                                                                        return pack_json(Lang_value_dict$BwaxAdmin.from_list(l));
                                                                                      }), Plate$BwaxAdmin.$$Option.map((function (param) {
                                                                                            return partial_arg((function (param) {
                                                                                                          return /* tuple */[
                                                                                                                  Runtime_common$BwaxAdmin.pack_string(param[0]),
                                                                                                                  pack_json(param[1])
                                                                                                                ];
                                                                                                        }), param);
                                                                                          }), Plate$BwaxAdmin.$$Option.map(Plate$BwaxAdmin.List.from_array, Plate$BwaxAdmin.$$Option.map(Js_dict.entries, Js_json.decodeObject(match[1])))));
                                                                        }
                                                                      } else {
                                                                        return invalid_args("decodeDict");
                                                                      }
                                                                    }))
                                                            ],
                                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                /* tuple */[
                                                                  "decodeRichText",
                                                                  pack_func(1, (function (param) {
                                                                          if (param) {
                                                                            var match = param[0][0];
                                                                            if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                                              return invalid_args("decodeRichText");
                                                                            } else {
                                                                              return Runtime_common$BwaxAdmin.pack_maybe(Runtime_common$BwaxAdmin.pack_string, Js_json.decodeString(match[1]));
                                                                            }
                                                                          } else {
                                                                            return invalid_args("decodeRichText");
                                                                          }
                                                                        }))
                                                                ],
                                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                    /* tuple */[
                                                                      "field",
                                                                      pack_func(2, (function (param) {
                                                                              if (param) {
                                                                                var match = param[0][0];
                                                                                if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                                                                  return invalid_args("field");
                                                                                } else {
                                                                                  var match$1 = match[0];
                                                                                  if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
                                                                                    return invalid_args("field");
                                                                                  } else {
                                                                                    var match$2 = param[1];
                                                                                    if (match$2) {
                                                                                      var match$3 = match$2[0][0];
                                                                                      if (typeof match$3 === "number" || !(match$3.tag === /* V_tagged_raw */8 && !match$2[1])) {
                                                                                        return invalid_args("field");
                                                                                      } else {
                                                                                        return Runtime_common$BwaxAdmin.pack_maybe(pack_json, Json$BwaxAdmin.get_by_path(/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                                          match$1[0],
                                                                                                          /* [] */0
                                                                                                        ]), match$3[1]));
                                                                                      }
                                                                                    } else {
                                                                                      return invalid_args("field");
                                                                                    }
                                                                                  }
                                                                                }
                                                                              } else {
                                                                                return invalid_args("field");
                                                                              }
                                                                            }))
                                                                    ],
                                                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                        /* tuple */[
                                                                          "at",
                                                                          pack_func(2, (function (param) {
                                                                                  if (param) {
                                                                                    var match = param[0][0];
                                                                                    if (typeof match === "number" || match.tag !== /* V_list */1) {
                                                                                      return invalid_args("at");
                                                                                    } else {
                                                                                      var match$1 = param[1];
                                                                                      if (match$1) {
                                                                                        var match$2 = match$1[0][0];
                                                                                        if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                                                                          return invalid_args("at");
                                                                                        } else {
                                                                                          var path = Plate$BwaxAdmin.List.map(Runtime_common$BwaxAdmin.extract_string, match[0]);
                                                                                          return Runtime_common$BwaxAdmin.pack_maybe(pack_json, Json$BwaxAdmin.get_by_path(path, match$2[1]));
                                                                                        }
                                                                                      } else {
                                                                                        return invalid_args("at");
                                                                                      }
                                                                                    }
                                                                                  } else {
                                                                                    return invalid_args("at");
                                                                                  }
                                                                                }))
                                                                        ],
                                                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                            /* tuple */[
                                                                              "index",
                                                                              pack_func(2, (function (param) {
                                                                                      if (param) {
                                                                                        var match = param[0][0];
                                                                                        if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                                                                          return invalid_args("index");
                                                                                        } else {
                                                                                          var match$1 = match[0];
                                                                                          if (typeof match$1 === "number" || match$1.tag) {
                                                                                            return invalid_args("index");
                                                                                          } else {
                                                                                            var match$2 = param[1];
                                                                                            if (match$2) {
                                                                                              var match$3 = match$2[0][0];
                                                                                              if (typeof match$3 === "number" || !(match$3.tag === /* V_tagged_raw */8 && !match$2[1])) {
                                                                                                return invalid_args("index");
                                                                                              } else {
                                                                                                return Runtime_common$BwaxAdmin.pack_maybe(pack_json, Json$BwaxAdmin.get_by_index(match$1[0], match$3[1]));
                                                                                              }
                                                                                            } else {
                                                                                              return invalid_args("index");
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      } else {
                                                                                        return invalid_args("index");
                                                                                      }
                                                                                    }))
                                                                            ],
                                                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                /* tuple */[
                                                                                  "parse",
                                                                                  pack_func(1, (function (param) {
                                                                                          if (param) {
                                                                                            var match = param[0][0];
                                                                                            if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                                                                              return invalid_args("parse");
                                                                                            } else {
                                                                                              var match$1 = match[0];
                                                                                              if (typeof match$1 === "number" || !(match$1.tag === /* String */2 && !param[1])) {
                                                                                                return invalid_args("parse");
                                                                                              } else {
                                                                                                return Runtime_common$BwaxAdmin.pack_maybe(pack_json, Json$BwaxAdmin.parse(match$1[0]));
                                                                                              }
                                                                                            }
                                                                                          } else {
                                                                                            return invalid_args("parse");
                                                                                          }
                                                                                        }))
                                                                                ],
                                                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                    /* tuple */[
                                                                                      "parseExn",
                                                                                      pack_func(1, (function (param) {
                                                                                              if (param) {
                                                                                                var match = param[0][0];
                                                                                                if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                                                                                  return invalid_args("parseExn");
                                                                                                } else {
                                                                                                  var match$1 = match[0];
                                                                                                  if (typeof match$1 === "number" || !(match$1.tag === /* String */2 && !param[1])) {
                                                                                                    return invalid_args("parseExn");
                                                                                                  } else {
                                                                                                    var match$2 = Json$BwaxAdmin.parse(match$1[0]);
                                                                                                    if (match$2 !== undefined) {
                                                                                                      return pack_json(Caml_option.valFromOption(match$2));
                                                                                                    } else {
                                                                                                      return invalid_args("parseExn");
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              } else {
                                                                                                return invalid_args("parseExn");
                                                                                              }
                                                                                            }))
                                                                                    ],
                                                                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                        /* tuple */[
                                                                                          "stringify",
                                                                                          pack_func(2, (function (param) {
                                                                                                  if (param) {
                                                                                                    var match = param[1];
                                                                                                    if (match) {
                                                                                                      var match$1 = match[0][0];
                                                                                                      if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                                                                                        return invalid_args("stringify");
                                                                                                      } else {
                                                                                                        var j = match$1[1];
                                                                                                        var match$2 = Runtime_common$BwaxAdmin.extract_maybe(param[0], Runtime_common$BwaxAdmin.extract_int);
                                                                                                        if (match$2 !== undefined) {
                                                                                                          return Runtime_common$BwaxAdmin.pack_string(JSON.stringify(j, null, match$2));
                                                                                                        } else {
                                                                                                          return Runtime_common$BwaxAdmin.pack_string(JSON.stringify(j));
                                                                                                        }
                                                                                                      }
                                                                                                    } else {
                                                                                                      return invalid_args("stringify");
                                                                                                    }
                                                                                                  } else {
                                                                                                    return invalid_args("stringify");
                                                                                                  }
                                                                                                }))
                                                                                        ],
                                                                                        /* [] */0
                                                                                      ])
                                                                                  ])
                                                                              ])
                                                                          ])
                                                                      ])
                                                                  ])
                                                              ])
                                                          ])
                                                      ])
                                                  ])
                                              ])
                                          ])
                                      ])
                                  ])
                              ])
                          ])
                      ])
                  ])
              ])
          ])
      ])
  ]);

var external_vals = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    external_vals_000,
    external_vals_001
  ]);

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  external_vals
];

var src = "\nmodule Json;\n\n-- Turn a String into a JSON string.\nstring: String -> JSON = external;\n\n-- Turn an Int into a JSON number.\nint: Int -> JSON = external;\n\n-- Turn a Float into a JSON number.\nfloat: Float -> JSON = external;\n\n-- Turn a Bool into a JSON boolean.\nbool: Bool -> JSON = external;\n\n\n-- A JSON null value singleton.\nnull: JSON = external;\n\n-- Turn a List into a JSON array\nlist: (a -> JSON) -> List a -> JSON = external;\n\n-- Create a JSON object using a list of key value pairs.\nobject: List (String, JSON) -> JSON = external; \n\n-- Turns a Dict into a JSON object.\ndict: (k -> String) -> (v -> JSON) -> Dict k v -> JSON = external;\n\n-- Turns any value to a JSON object.\nany: a -> Maybe JSON = external;\n\n\n-- Test the data type of JSON value\ntype Tagged = \n  | JSONNull \n  | JSONBoolean Bool \n  | JSONString String\n  | JSONNumber Float\n  | JSONArray (List JSON)\n  | JSONObject (Dict String JSON)\n;\n\nclassify: JSON -> Tagged = external;\n\n-- Decode:\n-- Decode a JSON string into a String\ndecodeString: JSON -> Maybe String = external;\n\n-- Decode a JSON boolean into a Bool\ndecodeBool: JSON -> Maybe Bool = external;\n\n-- Decode a JSON number into an Int\ndecodeInt: JSON -> Maybe Int = external;\n\n-- Decode a JSON number into a Float\ndecodeFloat: JSON -> Maybe Float = external;\n\n-- Decode a JSON array into a List \ndecodeList: JSON -> Maybe (List JSON) = external;\n\n-- Decode a JSON object into dict\ndecodeDict: JSON -> Maybe (Dict String JSON) = external;\n\n\ndecodeRichText: JSON -> Maybe RichText = external;\n\n\n-- Object helpers \n-- Get the JSON value of field from a JSON Object.\n-- If the field is missing or the JSON is not an object, return Nothing.\nfield: String -> JSON -> Maybe JSON = external;\n\n-- Get value of the field from a JSON object, with a decoder.\nfieldValue name decoder json: String -> (JSON -> Maybe a) -> JSON -> Maybe a = \n  json |> field name |> Maybe.andThen decoder\n;\n\n-- Get JSON value from a nested JSON object using the path\nat: List String -> JSON -> Maybe JSON = external;\n\n-- Get value from a nested JSON object using the path with a decoder.\nvalueAtPath path decoder json: List String -> (JSON -> Maybe a) -> JSON -> Maybe a = \n  json |> at path |> Maybe.andThen decoder\n; \n\n-- Get JSON value from a JSON array using the index.\nindex: Int -> JSON -> Maybe JSON = external;\n\n-- Get value from a JSON array using the index, with a decoder.\nvalueAtIndex idx decoder json: Int -> (JSON -> Maybe a) -> JSON -> Maybe a = \n  json |> index idx |> Maybe.andThen decoder\n;\n\n\n-- Parse a String represented JSON into a JSON.\nparse: String -> Maybe JSON = external;\n\n-- If the given string is not valid JSON, it will throws an evaluation exception.\nparseExn: String -> JSON = external;\n\n-- Stringify a JSON value. The first argument indicates whether the string should be prettified.\nstringify: Maybe Int -> JSON -> String = external;\n\n";

exports.src = src;
exports.module_name = module_name;
exports.invalid_args = invalid_args;
exports.pack_func = pack_func;
exports.pack_json = pack_json;
exports.default_config = default_config;
exports.any_value_to_json = any_value_to_json;
exports.any_value_to_plain_json = any_value_to_plain_json;
exports.external_vals = external_vals;
exports.externals = externals;
/* external_vals Not a pure module */
